import { render, staticRenderFns } from "./ReportsModal.vue?vue&type=template&id=b8150580"
import script from "./ReportsModal.vue?vue&type=script&lang=js"
export * from "./ReportsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports